import PropTypes from 'prop-types';
import Section from '../Section.jsx';
import styles from './SectionVideo.module.scss';

function SectionVideo({ src }) {
  return (
    <Section>
      <iframe
        width="560"
        height="315"
        src={ src }
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className={ styles.video }
      />
    </Section>
  );
}

SectionVideo.propTypes = {
  src: PropTypes.string.isRequired,
};

export default SectionVideo;
